module.exports = __webpack_public_path__ + "static/media/hire-team.09d01afb.png";